import React from 'react';
import '../../../styles/resume-editor.css';

interface CustomSectionProps {
  title: string;
  layout: 'inline' | 'stacked';
  onAddItem: () => void;
  onEdit: () => void;
  leftSidebarCollapsed?: boolean;
}

export const CustomSection: React.FC<CustomSectionProps> = ({
  title,
  layout,
  onAddItem,
  onEdit,
  leftSidebarCollapsed = false,
}) => {
  return (
    <div
      className="resume-editor__section"
      onClick={onEdit}
    >
      {!leftSidebarCollapsed && (
        <button
          className="resume-editor__section-toggle"
          onClick={(e) => {
            e.stopPropagation();
            onAddItem();
          }}
          title="Add item"
        >
          +
        </button>
      )}
      {!leftSidebarCollapsed && (
        <>
          <span className="resume-editor__section-text">{title}</span>
          <button
            className="resume-editor__section-custom-btn"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            title="Custom"
          >
            <svg
              className="resume-editor__section-custom-icon"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10Z"
                fill="#6b7280"
              />
              <path
                d="M6 3.5C6.28 3.5 6.5 3.72 6.5 4V5.5H8C8.28 5.5 8.5 5.72 8.5 6C8.5 6.28 8.28 6.5 8 6.5H6.5V8C6.5 8.28 6.28 8.5 6 8.5C5.72 8.5 5.5 8.28 5.5 8V6.5H4C3.72 6.5 3.5 6.28 3.5 6C3.5 5.72 3.72 5.5 4 5.5H5.5V4C5.5 3.72 5.72 3.5 6 3.5Z"
                fill="#6b7280"
              />
            </svg>
            <span>Custom</span>
          </button>
        </>
      )}
      {leftSidebarCollapsed && <span className="resume-editor__section-label">{title}</span>}
    </div>
  );
};

